import { FaArrowRight } from "react-icons/fa6"
import { Link } from "react-router-dom"

const AboutCard = () => {
    return (
        <div className="max-w-[27rem] w-full bg-white shadow-lg rounded-xl p-5 flex flex-col gap-8 py-8">
            <h2 className="text-red-600 uppercase font-bold text-sm">About Uniten</h2>
            <h1 className="text-3xl font-bold max-w-[8ch] text-[#040430]">
                Empowering Futures.
            </h1>
            <Link to="/campus-life" className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">Explore Campus <FaArrowRight /></span>
            </Link>
        </div>
    )
}

export default AboutCard